/**
 * BulkBar — the strip that appears above a table once rows are ticked:
 * "N selected · [actions…] · Clear". Admin-only (English).
 */

import React from 'react';
import { X } from 'lucide-react';

interface Props {
  count: number;
  noun?: string;
  onClear: () => void;
  children: React.ReactNode;
}

export const BulkBar: React.FC<Props> = ({ count, noun = 'selected', onClear, children }) => {
  if (count === 0) return null;
  return (
    <div className="d-flex flex-wrap align-items-center gap-2 rounded-2 px-3 py-2 mb-2" style={{ background: '#fff8e1', border: '1px solid #ffe082' }} role="region" aria-label="Bulk actions">
      <span className="fw-semibold small">{count} {noun}</span>
      <div className="d-flex flex-wrap align-items-center gap-2">{children}</div>
      <button type="button" className="btn btn-link btn-sm text-muted ms-auto p-0 d-inline-flex align-items-center gap-1" onClick={onClear}><X size={13} /> Clear</button>
    </div>
  );
};

export default BulkBar;
